import React, { useState } from "react";
import { Button, Typography } from "antd";
import CustomSelect from "../../../Common/CustomSelect";
import { questionsDefault, questionTypes } from "../../../../utils/surveys";
import { QuestionsList } from "../QuestionsList/QuestionsList";
import { Controller, useFieldArray, useFormContext } from "react-hook-form";
import { v4 as uuidv4 } from "uuid";
import { ErrorMessage } from "@hookform/error-message";
import CustomInput from "../../../Common/CustomInput";
import TextAreaEditor from "../../../Common/TextAreaEditor";

const QuestionsChildren = ({ pageIndex }) => {
    const [createQuestionType, setCreateQuestionType] = useState("");

    const selectNewQuestionHandler = (value) => {
        setCreateQuestionType(value);
    };

    const {
        control,
        formState: { errors },
    } = useFormContext();

    const {
        fields: questionsArr,
        append: appendQuestion,
        remove: removeQuestion,
        move: moveQuestion,
    } = useFieldArray({
        control,
        name: `pages[${pageIndex}].questions`,
    });

    const addNewQuestionHandler = () => {
        if (!createQuestionType) return;
        appendQuestion({
            ...questionsDefault[createQuestionType],
            id: uuidv4(),
        });
        setCreateQuestionType("");
    };

    const removeQuestionHandler = (id) => {
        const questionIndex = questionsArr.findIndex(
            (question) => question.id === id
        );

        if (questionIndex !== -1) {
            removeQuestion(questionIndex);
        }
    };

    return (
        <>
            <div
                style={{
                    padding: "20px",
                    display: "flex",
                    flexDirection: "column",
                    gap: "20px",
                }}
            >
                <Controller
                    control={control}
                    name={`pages[${pageIndex}].headline`}
                    render={({ field }) => (
                        <CustomInput
                            errors={errors}
                            label="Headline"
                            {...field}
                        />
                    )}
                />
                <Controller
                    control={control}
                    name={`pages[${pageIndex}].subheader`}
                    render={({ field }) => (
                        <TextAreaEditor
                            errors={errors}
                            label="Subheader"
                            {...field}
                        />
                    )}
                />
            </div>
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "20px",
                }}
            >
                <Button
                    size="middle"
                    type="primary"
                    onClick={addNewQuestionHandler}
                    style={{ fontSize: "24px", lineHeight: 0 }}
                >
                    +
                </Button>
                <CustomSelect
                    style={{ width: "200px" }}
                    onSelect={selectNewQuestionHandler}
                    label="Add Question"
                    errors={errors}
                    value={createQuestionType}
                    valueKey="value"
                    labelKey="label"
                    options={questionTypes}
                />
            </div>
            {errors?.pages?.[pageIndex]?.questions?.message && (
                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        marginTop: "10px",
                    }}
                >
                    <ErrorMessage
                        errors={errors}
                        name={`pages[${pageIndex}].questions`}
                        render={(data) => (
                            <Typography.Text type="danger">
                                * {data.message}
                            </Typography.Text>
                        )}
                    />
                </div>
            )}

            {questionsArr && questionsArr.length > 0 && (
                <div style={{ marginTop: "20px" }}>
                    <QuestionsList
                        pageIndex={pageIndex}
                        questionsName={`pages[${pageIndex}].questions`}
                        questions={questionsArr}
                        onDeleteQuestion={removeQuestionHandler}
                        move={moveQuestion}
                    />
                </div>
            )}
        </>
    );
};

export default QuestionsChildren;
